import { Platform, SubmissionType, UploadOperation } from 'src/types';
import { analytics } from '../analytics';
import { FILE_UPLOAD_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

interface TrackFileUploadUpdatedProps {
  organisation_id?: string;
  file_type: string;
  file_size: number; // in bytes
  error?: string;
  operation: UploadOperation;
  submissionType: SubmissionType;
  platform: Platform;
}

const uploadEventMap: { [key in Platform]: FILE_UPLOAD_EVENT_IDS } = {
  [Platform.OPR]: FILE_UPLOAD_EVENT_IDS.OPR_FILE_UPLOAD_UPDATED,
  [Platform.REPORTING]: FILE_UPLOAD_EVENT_IDS.REPORTER_HUB_FILE_UPLOAD_UPDATED,
};

export const trackFileUploadUpdated = (
  properties: TrackFileUploadUpdatedProps,
) => {
  const eventId = uploadEventMap[properties.platform];
  return analytics.track(eventId, properties, {
    context: { ip: generateRandomIPAddress() },
  });
};
